import { makeStyles, shorthands } from "@fluentui/react-components";

export const mainStyle = makeStyles({
  chatBot: {
    display: "flex",
    flexDirection: "column",
    height: "98vh",
    width: "98%",
    boxSizing: "border-box",
  },
  chatBotWord: {
    display: "flex",
    flexDirection: "column",
    height: "98vh",
    width: "96%",
    boxSizing: "border-box",
    marginLeft: "4px",
  },
  messageList: {
    flexGrow: 1,
    overflowY: "auto", // Makes it scrollable vertically
    ...shorthands.margin("0", "0", "10px", "0"), // Margin at the bottom
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(53, 124, 124, 0.3) !important",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(53, 124, 124, 0.6) !important",
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  pinTooltipPlaceholder: {
    position: "absolute",
    right: 0,
    top: 0,
    width: 0,
    height: 0,
    pointerEvents: "none",
    paddingRight: "50px",
  },
  minimizedChatBot: {
    display: "flex",
    flexDirection: "column",
    height: "98vh",
    width: "100px",
    boxSizing: "border-box",
  },
});
